import { render, staticRenderFns } from "./SkinItemDetails.vue?vue&type=template&id=47db6493&"
import script from "./SkinItemDetails.vue?vue&type=script&lang=js&"
export * from "./SkinItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports